import React, { useState, useEffect, useReducer, useRef, useMemo } from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Tooltip,
  TableHead,
  TableRow,
  Input,
  TablePagination,
  Typography,
  IconButton,
  TextField,
  Button,
  Stack,
  Box,
} from "@mui/material";
import { PlantNotesColumns } from "./columns";
import { AddNewPlantNoteDialog } from "popup/AddNewPlantNoteDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import { tlmDeletePlantNote } from "layouts/dashboard/apiService";
import NoData from "components/NoData";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import PushPinIcon from "@mui/icons-material/PushPin";
import AddIcon from "@mui/icons-material/Add"; // Import dell'icona Add
import {
  tlmPostPinPlantNote,
  tlmGetPlantNotes,
} from "layouts/dashboard/apiService";
import { APIStatusDialog } from "components/APIStatusDialog";
import { I18n } from "@aws-amplify/core";
import { fetchAuthSession } from "aws-amplify/auth";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { get } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";
import { useRefresh } from "layouts/dashboard/RefreshContext";
import ConfirmDeleteStoreNote from "popup/ConfirmDeleteStoreNote";
export const RenderPlantNote = ({
  notePlantState,
  resourcePrefPage,
  rowsPerResourcePrefPage,
  setResourcePrefPage,
  setRowsPerResourcePrefPage,
  account_number,
  endDate,
  startDate,
  dispatchNotePlant,
  setStartDate,
  setEndDate,
  profile,
}) => {
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  const isAdmin =
    profile && (profile.includes("Admin") || profile.includes("SuperAdmin"));
  const formatTimestamp = (timestamp) =>
    dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss");
  const [tableParentIsMD, setTableParentIsMD] = useState(false);
  const toolbarRef = useRef(null);
  useEffect(() => {
    const parentElement = toolbarRef.current;
    if (!parentElement) {
      console.error("toolbarRef is not correctly attached to any DOM element.");
      return;
    }
    const checkSize = (width) => {
      const breakpoint = 960; // 960px is md
      setTableParentIsMD(width < breakpoint);
    };
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        checkSize(entry.contentRect.width);
      }
    });
    resizeObserver.observe(parentElement);
    checkSize(parentElement.offsetWidth);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const plantNotesColumns = PlantNotesColumns();
  const { handleRefresh } = useRefresh();
  const [deleteNoteConfirmPopup,setDeleteNoteConfirmPopup]=useState(false)
  const [mappingId, setMappingId]=useState(0);
  const [userInfo, setUserInfo] = useState({
    email: "",
    name: "",
    profiles: ["NOT ADMIN"],
  });
  const normalizeEmail=(email)=>email.normalize("NFKC").replace(/\u200B|\uFEFF/g, "").replace(/[\u2010-\u2015\u2212\uFE63\uFF0D]/g, "-").trim().toLowerCase()
  const tlmGetUserGroups = async (userID) => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/userManagement/user/groups",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: { user_id: userID },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();

      // Extract profiles from the response and set groupNameSel with the first profile
      const profiles = response.profiles.map((profile) => profile.group_name);
      return profiles;
    } catch (error) {
      console.error("Error fetching user groups:", error);
    }
  };
  useEffect(() => {
    async function currentSession() {
      try {
        const { accessToken, idToken } =
          (await fetchAuthSession()).tokens ?? {};
        const profiles = await tlmGetUserGroups(
          idToken.payload["cognito:username"]
        );

        setUserInfo({
          name: idToken.payload.name || "No Name",
          email: idToken.payload.email || "No email",
          profiles: profiles || [],
        });

        // Save profiles to setProfile
      } catch (err) {}
    }

    currentSession();
  }, []);
  const handlePinClick = async (noteID, currentPinnedValue) => {
    const newPinnedValue = !currentPinnedValue;
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Pinning"),
      });
      const restOperation = await tlmPostPinPlantNote(noteID, newPinnedValue);
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Pinned successfully"),
        });
        const plantNoteResponse = await tlmGetPlantNotes(
          account_number,
          endDate,
          startDate
        );
        dispatchNotePlant({ type: "DATA_RECEIVED", value: plantNoteResponse });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Error Pinned"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
      handleRefresh();
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Error Pinned"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };

  const handleDeleteNote = async (noteID) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Deleting plant note"),
      });
      const restOperation = await tlmDeletePlantNote(noteID);
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Store Note deleted successfully"),
        });
        const response = await tlmGetPlantNotes(
          account_number,
          endDate,
          startDate
        );
        dispatchNotePlant({ type: "DATA_RECEIVED", value: response });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Error deleting store note"),
        });
      }
      setDeleteNoteConfirmPopup(false)
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
      handleRefresh();
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Error deleting store note"),
      });
      setDeleteNoteConfirmPopup(false)
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };
  if (!notePlantState.data || notePlantState.data.length === 0) {
    return (
      <Card>
        <CardContent sx={{ padding: "1rem" }}>
          <Stack
            spacing={2}
            direction={tableParentIsMD ? "column" : "row"}
            alignItems="center"
            sx={{ pb: 2 }}
          >
            <Tooltip title={I18n.get("Add New Store Note")}>
              <IconButton
                onClick={() => setOpenAddDialog(true)}
                disabled={!isAdmin}
              >
                <AddIcon />
              </IconButton>
            </Tooltip>

            <Box
              sx={{
                ml: 2,
                flexGrow: 1,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Typography variant="h5">{I18n.get("Store Note")}</Typography>
            </Box>
          </Stack>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NoData />
          </Box>
        </CardContent>
        <AddNewPlantNoteDialog
          open={openAddDialog}
          onClose={() => setOpenAddDialog(false)}
          accountNumber={account_number}
          dispatchNotePlant={dispatchNotePlant}
          startDate={startDate}
          endDate={endDate}
        />
        <APIStatusDialog
          open={apiStatus.open}
          status={apiStatus.status}
          message={apiStatus.message}
        />
      </Card>
    );
  }
  return (
    <Card>
      <CardContent sx={{ padding: "1rem" }}>
        <Stack
          spacing={2}
          direction={tableParentIsMD ? "column" : "row"}
          alignItems="center"
          paddingBottom="1rem"
        >
          <Tooltip title={I18n.get("Add New Store Note")}>
            <IconButton
              onClick={() => setOpenAddDialog(true)}
              disabled={!isAdmin}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>

          <Box
            sx={{
              ml: 2,
              flexGrow: 1,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Typography variant="h5"> {I18n.get("Store Note")}</Typography>
          </Box>
        </Stack>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {plantNotesColumns.map((column) => (
                  <TableCell key={column.id}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {notePlantState.data
                .slice(
                  resourcePrefPage * rowsPerResourcePrefPage,
                  resourcePrefPage * rowsPerResourcePrefPage +
                    rowsPerResourcePrefPage
                )
                .map((mappingRow, rowIndex) => {
                  
                  return(
                  <TableRow key={rowIndex}>
                    {plantNotesColumns.map((column, colIndex) => (
                      <TableCell sx={{ padding: "0px" }} key={colIndex}>
                        {" "}
                        {/** Rimosso padding */}
                        {column.id === "timestamp" ? (
                          formatTimestamp(mappingRow[column.id]) // Apply timestamp formatting here
                        ) : column.id === "pinned" ? (
                          <Tooltip
                            title={
                              !isAdmin 
                                ? I18n.get("Unauthorized User")
                                : ""
                            }
                            arrow
                          >
                            <span>
                              <IconButton
                                disabled={!isAdmin}
                                onClick={() =>
                                  handlePinClick(
                                    mappingRow.id,
                                    mappingRow.pinned
                                  )
                                }
                              >
                                {mappingRow.pinned ? (
                                  <PushPinIcon />
                                ) : (
                                  <PushPinOutlinedIcon />
                                )}
                              </IconButton>
                            </span>
                          </Tooltip>
                        ) : column.id === "action" ? (
                          <Tooltip
                            // title={
                            //   !isAdmin || normalizeEmail(userInfo.email) !==
                            //   normalizeEmail(mappingRow.executor)
                            //     ? I18n.get("Unauthorized User")
                            //     : ""
                            // }
                            title={
                              !isAdmin 
                                ? I18n.get("Unauthorized User")
                                : ""
                            }
                            arrow
                          >
                            <span>
                              <IconButton
                                onClick={() => {setMappingId(mappingRow.id); setDeleteNoteConfirmPopup(true)}}
                                // disabled={!isAdmin||normalizeEmail(userInfo.email) !==
                                //   normalizeEmail(mappingRow.executor)} // Disables delete button if user is guest
                                disabled={!isAdmin}
                              >
                                <DeleteIcon /> {/* Display delete icon */}
                              </IconButton>
                            </span>
                          </Tooltip>
                        ) : mappingRow[column.id] !== undefined &&
                          mappingRow[column.id] !== null ? (
                          mappingRow[column.id]
                        ) : (
                          ""
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                )})}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={notePlantState.data.length}
          page={resourcePrefPage}
          onPageChange={(event, newPage) => setResourcePrefPage(newPage)}
          rowsPerPage={rowsPerResourcePrefPage}
          onRowsPerPageChange={(event) => {
            setRowsPerResourcePrefPage(parseInt(event.target.value, 10));
            setResourcePrefPage(0);
          }}
          rowsPerPageOptions={[]}
        />
      </CardContent>
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
      <AddNewPlantNoteDialog
        open={openAddDialog}
        onClose={() => setOpenAddDialog(false)}
        accountNumber={account_number}
        dispatchNotePlant={dispatchNotePlant}
        startDate={startDate}
        endDate={endDate}
      />
      <ConfirmDeleteStoreNote
      open={deleteNoteConfirmPopup}
      onClose={()=>setDeleteNoteConfirmPopup(false)}
      onConfirm={()=>handleDeleteNote(mappingId)}/>
    </Card>
  );
};
